/* Emma Luu Studios — Custom JS
   Phase 1: sticky nav, mobile drawer, hero slider, footer accordion.
   No auto-advance on slider. No animations yet — see ANIMATION comments. */

document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initMobileDrawer();
  initHeroSlider();
  initFooterAccordion();
});

/* ── Sticky nav ──────────────────────────────────────────────── */
function initNav() {
  const header = document.getElementById('el-site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    header.classList.toggle('is-scrolled', window.scrollY > 80);
  }, { passive: true });
}

/* ── Mobile drawer ───────────────────────────────────────────── */
function initMobileDrawer() {
  const hamburger = document.getElementById('el-hamburger-btn');
  const drawer    = document.getElementById('el-mobile-drawer');
  const closeBtn  = document.getElementById('el-drawer-close-btn');
  const overlay   = document.getElementById('el-drawer-overlay');

  if (!hamburger || !drawer) return;

  /* ANIMATION: add slide-in transform transition in animation phase */

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay?.classList.add('is-visible');
    hamburger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const firstFocusable = drawer.querySelector('button, a, input');
    firstFocusable?.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    hamburger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hamburger.focus();
  }

  hamburger.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* Trap focus inside drawer when open */
  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('button, a, input, [tabindex]:not([tabindex="-1"])')];
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
}

/* ── Hero slider ─────────────────────────────────────────────── */
function initHeroSlider() {
  /* ANIMATION: add crossfade transition (opacity/transform) in animation phase */
  const slider = document.querySelector('.el-hero-slider');
  if (!slider) return;

  const slides   = [...slider.querySelectorAll('.el-hero-slide')];
  const dots     = [...slider.querySelectorAll('.el-hero-dot')];
  const prevBtn  = slider.querySelector('.el-hero-arrow--prev');
  const nextBtn  = slider.querySelector('.el-hero-arrow--next');

  if (slides.length === 0) return;

  let current = 0;

  function showSlide(index) {
    slides[current].classList.remove('is-active');
    dots[current]?.classList.remove('is-active');
    dots[current]?.setAttribute('aria-current', 'false');

    current = index;

    slides[current].classList.add('is-active');
    dots[current]?.classList.add('is-active');
    dots[current]?.setAttribute('aria-current', 'true');

    if (prevBtn) prevBtn.classList.toggle('is-hidden', current === 0);
    if (nextBtn) nextBtn.classList.toggle('is-hidden', current === slides.length - 1);
  }

  showSlide(0);

  prevBtn?.addEventListener('click', () => {
    if (current > 0) showSlide(current - 1);
  });

  nextBtn?.addEventListener('click', () => {
    if (current < slides.length - 1) showSlide(current + 1);
  });

  dots.forEach((dot, i) => dot.addEventListener('click', () => showSlide(i)));
}

/* ── Footer accordion (mobile only) ─────────────────────────── */
function initFooterAccordion() {
  /* ANIMATION: add max-height transition in animation phase */
  const toggles = document.querySelectorAll('.el-footer-col-toggle');

  toggles.forEach((toggle) => {
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const col  = toggle.closest('.el-footer-col');
      const list = col?.querySelector('.el-footer-links-list');
      const icon = toggle.querySelector('.el-footer-toggle-icon');

      toggle.setAttribute('aria-expanded', String(!expanded));
      list?.classList.toggle('is-open', !expanded);
      if (icon) icon.textContent = expanded ? '+' : '–';
    });
  });
}
